// Enter all your detials in this file
// Logo images
import logogradient from "./assets/RRR.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.svg";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import js from "./assets/techstack/js.png";
import nodejs from "./assets/techstack/Node.js.png";
import express from "./assets/techstack/Express.png";
import nextjs from "./assets/techstack/Next.js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import mongo from "./assets/techstack/MongoDB.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
import python from "./assets/techstack/python.png";
import scrapy from "./assets/techstack/scrapy.png";
import pandas from "./assets/techstack/pandas.png";
import numpy from "./assets/techstack/numpy.png";
import scikitlearn from "./assets/techstack/sclearn.png";
import jupyter from "./assets/techstack/Jupyter.png"
import colab from "./assets/techstack/colab.png"
import azure from "./assets/techstack/Azure.png"
import vercel from "./assets/techstack/Vercel.png"
import ps from "./assets/techstack/ps.png"
import ai from "./assets/techstack/ai.png"

// Porject Images
import projectImage1 from "./assets/projects/project1.jpg";
import projectImage2 from "./assets/projects/project2.jpg";
import projectImage3 from "./assets/projects/project3.jpg";
import projectImage4 from "./assets/projects/project4.jpg";
import projectImage5 from "./assets/projects/project5.jpg";
import projectImage6 from "./assets/projects/project6.jpg";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Rahat Rahman Rumi",
  tagline: "I build things for web",
  img: profile,
  about: `As a passionate Web Developer with a diverse skill set, I am driven by a constant curiosity to explore new technologies and refine my abilities. Specializing in full-stack development, automation, and Python development, I also bring a strong background in graphic design and proficiency with soft office tools. Committed to staying ahead of industry trends, I apply innovative solutions to every project. My focus on continuous learning enables me to push both creative and technical boundaries, delivering high-quality results that exceed expectations. Explore my portfolio to discover how I combine these skills to bring fresh, cutting-edge ideas to life.`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/",
  github: "https://www.github.com/",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Web Developer & Automation Specialist",
    Company: `Avercom`,
    Location: "Bangladesh",
    Type: "Part Time",
    Duration: "Jan 2021 - Present",
  }
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Python Development",
    Company: "Udemy, YouTube, Google, Medium",
    Location: "Online",
    Type: "Full Time",
    Duration: "Aug 2020 - Present",
  },
  {
    Position: "Full-Stack Development",
    Company: "Udemy, YouTube, Google, Medium",
    Location: "Online",
    Type: "Full Time",
    Duration: "Jan 2020 - Present",
  },
  {
    Position: "IGCSE and A Level Student",
    Company: `Penfield School`,
    Location: "Bangladesh",
    Type: "Full Time",
    Duration: "Jan 2020 - Jan 2024",
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  nodejs: nodejs,
  express:express,
  react: react,
  redux: redux,
  mongo: mongo,
  nextjs: nextjs,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
  python: python,
  scrapy: scrapy,
  pandas: pandas,
  numpy: numpy,
  scikitlearn: scikitlearn,
  jupyter:jupyter,
  colab:colab,
  azure:azure,
  vercel:vercel,
  ps:ps,
  ai:ai
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "Project title 1",
    image: projectImage1,
    description: `This is sample project description random things are here in description This is sample
project lorem ipsum generator for dummy content`,
    techstack: "HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "Project title 2",
    image: projectImage2,
    description: `This is sample project description random things are here in description This is sample
project lorem ipsum generator for dummy content`,
    techstack: "HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "Project title 3",
    image: projectImage3,
    description: `This is sample project description random things are here in description This is sample
project lorem ipsum generator for dummy content`,
    techstack: "HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "Project title 4",
    image: projectImage4,
    description: `This is sample project description random things are here in description This is sample
project lorem ipsum generator for dummy content`,
    techstack: "HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "Project title 5",
    image: projectImage5,
    description: `This is sample project description random things are here in description This is sample
project lorem ipsum generator for dummy content`,
    techstack: "HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "Project title 6",
    image: projectImage6,
    description: `This is sample project description random things are here in description This is sample
project lorem ipsum generator for dummy content`,
    techstack: "HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "rahat87942@gmail.com",
};
